/* eslint-disable max-len */
import { Avatar, Badge, Box } from "@mui/material";
import { StarIcon } from "assets/Icons";
import { FunctionField } from "react-admin";
import { Link, useLocation } from "react-router-dom";

const UserAvatarAndName = ({
  nameStyles,
  fromAppointmentList = false,
  clickable = true,
  label,
  sx,
  withMarginTop
}: {
  label?: string;
  fromAppointmentList?: boolean;
  nameStyles?: string;
  clickable?: boolean;
  sortBy?: string;
  sx?: any;
  withMarginTop?: boolean;
}) => {
  const router = useLocation();

  const isUserList = router.pathname.split("/").includes("User");

  return (
    <FunctionField
      data-label={label + ":"}
      sx={{ marginTop: withMarginTop ? "6px" : "0px" }}
      render={(record: any) => (
        <div
          className="max-w-fit"
          onClick={(e) => clickable && e.stopPropagation()}
          aria-hidden
        >
          <Link
            to={
              !clickable
                ? ""
                : `/dashboard/${isUserList ? "User" : "Customer"}/${
                    record?.user?.id || record?.id
                  }/show`
            }
            className={`flex items-center gap-[16px] ${
              !clickable ? "cursor-default" : ""
            }`}
          >
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                fromAppointmentList &&
                record?.user?.appointments?.length === 1 ? (
                  <div
                    className="w-[12px] h-[12px] flex justify-center items-center
                    rounded-[6px] bg-mono-primaryLightBgColor"
                  >
                    <StarIcon />
                  </div>
                ) : (
                  <div />
                )
              }
            >
              <Avatar
                sx={{
                  bgcolor: "rgba(238, 234, 228, 0.9)",
                  color: "rgba(48, 47, 46, 0.95)",
                  width: "32px",
                  height: "32px",
                  fontFamily: "Inter",
                  fontSize: "18px",
                  "@media screen and (max-width:800px)": {
                    width: "24px",
                    height: "24px",
                    fontSize: "16px"
                  }
                }}
                alt={record?.first_name || record?.user?.first_name}
                src={record?.photo_url || record?.user?.photo_url || "monogram"}
              />
            </Badge>
            <Box
              component="p"
              className={`font-['Inter'] leading-[1.43] ${
                !clickable ? "text-mono-primaryTextColor" : "text-mono-link"
              } ${nameStyles ? nameStyles : "text-[14px]"}`}
              sx={sx}
            >
              {`${record?.first_name || record?.user?.first_name} ${
                record?.last_name || record?.user?.last_name
              }`}
            </Box>
          </Link>
        </div>
      )}
    />
  );
};

export default UserAvatarAndName;
